// COOKIE-REVIEW: Direct (native) auth flow reduces reliance on hosted UI cookies; tokens handled client-side.
export default {
    // directClientId: process.env.PREACT_APP_COGNITO_DIRECT_CLIENT
    directClientId: process.env.PREACT_APP_COGNITO_CLIENT_ID,
    domain: process.env.PREACT_APP_COGNITO_ENDPOINT,
};